import React from "react";
import AnalyticsControls from './AnalyticsControls'
import AnalyticsChart from './AnalyticsChart'
import {Metrics} from './AnalyticsCommon'

import AnalyticsService from 'services/AnalyticsService'

import "./Analytics.css"

const Analytics: React.FC<{dimId: string}> = (props) => {
    const [config, setConfig] = React.useState<any>(null)
    const [chartData, setChartData] = React.useState<any>(null)

    async function getAnalyticsData(config: any) {
        return AnalyticsService.getAnalytics({
            ...config, 
            ...{ dimension: props.dimId }
        })
    }

    async function getAnalytics(config: any) {
        let data = await getAnalyticsData(config)
        setChartData({config: config, data: data})
    }

    return (
        <div className="analytics-container">
            <AnalyticsControls getAnalytics={getAnalytics}/>
            <AnalyticsChart data={chartData} fillGaps={true}/>
        </div>
      );
};

export default Analytics;
